<template>
  <div class="model-edit-form">
    <ModelEditFormWrapper
      v-for="(modelFormConfig, i) in modelFormConfigs"
      :key="modelFormConfig.id"
      :model-form-config="modelFormConfig"
      :disabled="!isOnTop(i)"
      @close="isOnTop(i) ? modelFormStore.closeForm(modelFormConfig.id!) : undefined"
    />
  </div>
</template>

<script setup lang="ts">
import ModelEditFormWrapper from "@/components/model_edit_form/ModelEditFormWrapper.vue"
import { useModelFormStore } from "@/store/model-forms.store"
import { storeToRefs } from "pinia"

const modelFormStore = useModelFormStore()
const { modelFormConfigs } = storeToRefs(modelFormStore)

function isOnTop(i: number) {
  return i === modelFormConfigs.value.length - 1
}
</script>

<style scoped></style>
